import AuthService from '../api/auth/authentication';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? {
    status: {
      loggedIn: true
    }, user
  } : {
    status: {
      loggedIn: false
    }, user: null
  };

export const auth = {
  namespaced: true,
  state: initialState,
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  },
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          if (user) {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          } else {
            commit('loginFailure');
            return Promise.reject(user)
          }

        },
        error => {
          console.error("login error : ", error);
          commit('loginFailure');
          return Promise.reject(error)
        }
      );
    },
    logout({ commit }) {
      // Promise-nya dikembalikan supaya pemanggil bisa menunggu sesi benar-benar
      // bersih sebelum berpindah halaman.
      return AuthService.logout().then(() => {
        commit('logout');
      });
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        res => {
          if (res) {
            commit('registerSuccess');
            return Promise.resolve(res)
          } else {
            commit('registerFailure');
            return Promise.reject(res);
          }

        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      )
    },
    registerMitra({ commit }, data) {
      return AuthService.registerMitra(data)
      .then(res => {
        if (res) {
          commit('registerSuccess');
          return Promise.resolve(res);
        } else {
          commit('registerFailure');
          return Promise.reject(res);
        }
      })
      .catch(err => {
        commit('registerFailure');
        return Promise.reject(error);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.module.js